module.exports = __webpack_public_path__ + "img/SwiftScan.a0a0e3d1.png";